import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { FAQS } from "../data/seoContent";

// Accordion FAQ section. Renders visible Q&A; FAQPage schema is emitted via <Seo jsonLd> by the page.
export const FaqSection = ({ items = FAQS, title = "Frequently Asked Questions", subtitle = "Everything you need to know about ordering cakes with Globaltreats." }) => {
  const [open, setOpen] = useState(0);
  return (
    <section className="max-w-3xl mx-auto px-4 md:px-8 py-16" data-testid="faq-section">
      <div className="text-center mb-10">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-[#3A2417]">{title}</h2>
        <p className="text-[#B07A5C] mt-2">{subtitle}</p>
      </div>
      <div className="space-y-3">
        {items.map((f, i) => {
          const isOpen = open === i;
          return (
            <div key={i} className="bg-white rounded-2xl bakery-shadow overflow-hidden" data-testid={`faq-item-${i}`}>
              <button
                type="button"
                onClick={() => setOpen(isOpen ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 hover:bg-[#FCEFE3]/50 transition-colors"
                data-testid={`faq-question-${i}`}
                aria-expanded={isOpen}
              >
                <span className="font-medium text-[#3A2417] text-sm md:text-base">{f.q}</span>
                <ChevronDown size={20} className={`text-[#D46A8A] shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
              </button>
              <div className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                <div className="overflow-hidden">
                  <p className="px-5 pb-5 text-sm text-[#6B4226] leading-relaxed">{f.a}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FaqSection;
